import React from "react";

// Cinematic static grain/noise overlay for dark sections.
const NOISE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>"
  );

export const GrainOverlay = ({ opacity = 0.18 }) => (
  <div
    aria-hidden="true"
    className="pointer-events-none absolute inset-0 z-10 mix-blend-overlay"
    style={{ backgroundImage: `url("${NOISE}")`, backgroundSize: "180px 180px", opacity }}
  />
);

export default GrainOverlay;
